// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3B2lh","insightsList":"newBusinessInsightsMenu_insightsList__W2yWT","active":"newBusinessInsightsMenu_active__3g7mC"};